<template>
  <transition name="slide" appear>
    <div class="trip-summary-wrapper content-wrapper">
      <MainMenuWithPreferences pageTitle="My Trip" class="header">
        <template slot="preferences-menu">
          <MainMenuPreferencesBlock />
        </template>
      </MainMenuWithPreferences>

      <div class="mobile-wrapper view-container">
        <div class="mobile-overlay">
          <div class="img"></div>
          <div class="text-primary"><b>Access Trip Planner from your desktop browser</b></div>
          <div class="text-secondary">
            Mobile devices are currently not supported. Plan your next trip from your web browser on your computer or
            laptop.
          </div>
        </div>

        <div class="explore-header" :class="{extended: isSummaryMapActive}">
          <div class="map-container">
            <div class="map-holder bg-extender" :class="{active: isSummaryMapActive}" ref="top">
              <SolutionMap
                :isMapFull="isSummaryMapActive"
                :isMapActive="isSummaryMapActive"
                @show-details="onShowPoiDetailsFromMap"
              >
                <template v-slot:toggle>
                  <div></div>
                </template>
              </SolutionMap>
            </div>
          </div>
          <div class="header-wrapper">
            <div class="button-wrapper">
              <div
                class="header-back header-back--explore"
                v-if="detailsCategoryText && !isRecommendationDetailsVisible"
              >
                <button class="explore-btn" @click="backToExplore">&lt; Back to EXPLORE</button>
              </div>

              <div class="header-category" v-if="detailsCategoryText && !isRecommendationDetailsVisible">
                {{ detailsCategoryText }}
              </div>
            </div>

            <div class="search-wrapper">
              <div class="search">
                <SearchInput
                  class="search-input-cls"
                  :value="searchInputValue"
                  @input="onSearchInputChange"
                  placeholder="Find ..."
                />
                <div class="filters-search-resutls" v-if="filterOptions.length || searchOptions.length">
                  <div class="search-section-wrapper" v-if="filterOptions.length">
                    <span class="title">Filters</span>
                    <AmexDropdown :active="filterOptions.length > 0" class="dropdown">
                      <InterestDropItem
                        @click="toggleTag(item)"
                        :value="item.parent"
                        :label="item.text"
                        :tag="item"
                        :withCheck="item.isActive"
                        class="select-option"
                        v-for="item in filterOptions"
                        :key="item.id"
                      />
                    </AmexDropdown>
                  </div>
                  <div class="search-section-wrapper" v-if="searchOptions.length">
                    <span class="title">Places</span>
                    <AmexDropdown :active="searchOptions.length > 0" class="dropdown">
                      <ExpItem
                        v-for="item in searchOptions"
                        :key="item.id"
                        :activity="item"
                        :isRemoveAllowed="false"
                        class="select-option"
                        @click="onSelectSearchPoi(item)"
                      />
                    </AmexDropdown>
                  </div>
                </div>
              </div>
            </div>

            <div class="map-toggle-wrapper">
              <div class="map-toggle" :class="{active: isSummaryMapActive}">
                <ToggleComponent :value="isSummaryMapActive" @change="onToggleSummaryMap" id="map-toggle-summary" />
                <label for="map-toggle-summary" class="map-toggle-label">Show Map</label>
              </div>
            </div>
          </div>
        </div>

        <div class="mobiamex-tripsummary" id="tripSummary">
          <div class="sidebar shrink" :class="{active: isSidebarVisible}">
            <div class="trip-img-wrapper">
              <TripBg class="solution-img" :img="solutionImg" />
              <div class="trip-header">
                <div class="trip-dates">{{ dateValueFormatted }}</div>
                <div class="trip-details-caption">Trip Details</div>
              </div>
            </div>

            <nav class="explore-nav">
              <button class="exp-nav-tab" :class="{active: isSavedPlacesActive}" @click="openSavedPlaces">
                Saved Places
              </button>
              <button class="exp-nav-tab" :class="{active: isItinerarysActive}" @click="openItinerary">
                Itinerary
              </button>
            </nav>

            <ExpList
              v-if="isItinerarysActive"
              class="exp-list"
              :removedItems="removedItems"
              :isRecommendationsOn="false"
              :solutionRecommendations="solutionRecommendations"
              @show-details="openHighlightDetails"
              @remove-item="onRemoveFromTheList"
              @open-category="onOpenCategory"
              @show-recommendation="openHighlightDetails"
            >
              <template v-slot:actions="{nothingYet}">
                <div class="update-trip-btns">
                  <button
                    class="book-trip-btn update-trip"
                    @click="onUpdateSolution"
                    :disabled="!manualActivities || isSolutionLoading"
                    v-if="solution"
                  >
                    <span v-if="nothingYet">Build Itinerary</span>
                    <span v-else>Update Itinerary</span>
                  </button>

                  <button class="book-trip-btn" @click="onBookingOpen" :disabled="isSolutionLoading" v-if="solution">
                    Book
                  </button>
                </div>
              </template>
            </ExpList>

            <SavedList v-if="isSavedPlacesActive" class="exp-list" @show-details="openHighlightDetails">
              <template v-slot:actions="{nothingYet}">
                <div class="update-trip-btns">
                  <button
                    class="book-trip-btn update-trip"
                    @click="onUpdateSolution"
                    :disabled="!manualActivities || isSolutionLoading"
                    v-if="solution"
                  >
                    <span v-if="nothingYet">Build Itinerary</span>
                    <span v-else>Update Itinerary</span>
                  </button>

                  <button class="book-trip-btn" @click="onBookingOpen" :disabled="isSolutionLoading" v-if="solution">
                    Book
                  </button>
                </div>
              </template>
            </SavedList>
          </div>
          <TripContent class="shrinkable contentPane right expanded">
            <transition name="slide-left">
              <div class="box" ref="tourStartElement">
                <router-view />
              </div>
            </transition>
          </TripContent>

          <div class="save-dialog" v-if="saveDialog">
            <SummarySaveDialog
              @download="onDownloadPdf"
              @save="onSaveTrip"
              @close="onCloseSaveTrip"
              :image="solutionImg"
              :tripName="destinationName"
              :isPDFLoading="isPDFLoading"
            ></SummarySaveDialog>
            <div class="save-dialog__overlay" />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Vue from 'vue';
import MdModalDialog from 'vue-material-modal-dialog';
import 'vue-material-modal-dialog/dist/components.css';
import {MdDialog} from 'vue-material/dist/components';
import VueCompositionAPI, {computed, ref, watch} from '@vue/composition-api';
import {ToggleComponent} from '@mobi-components/toggle';
import '@mobi-components/toggle/dist/toggle.css';
import {useParams, useQueryParams} from '@/router/router';
import SummarySaveDialog from '@components/summary-page/summary-save-dialog';
// import PoweredByMobi from '@common/powered-by-mobi.vue';
import {AmexDropdown, InterestDropItem} from '@mobi-components/amex-bluesky-components';
import SearchInput from './search-input.vue';

import ExpItem from './exp-list/exp-item.vue';
import {getModalFilterConfig} from '@components/old-home-page/modal-filter.config';

Vue.use(VueCompositionAPI);
Vue.use(MdDialog);
Vue.use(MdModalDialog);

import {TripContent, TripBg} from '@mobi-components/amex-bluesky-components';
import '@mobi-components/amex-bluesky-components/dist/amex-bluesky-components.css';
import ExpList from './exp-list/exp-list.vue';
import {useExploreView, useSessionValidation} from './explore-page-helper';
import '@mobi-components/amex-poi-details-view/dist/amex-poi-details-view.css';
import {useSaveSolutionDialog} from '../summary-page/useSaveSolutionDialod';
import SolutionMap from '../summary-page/solution-map.vue';
import {useSummary} from '../summary-page/summary-page-helper';
import {useBookings} from '../summary-page/summary-booking/booking-list';
import {useCommonFind} from '../solution-views/explore-view/common-find';
import {ProblmSubmissionRoute} from '@/store/state/global.types';
import {allovedInterestDomains} from '@components/old-home-page/home-helpers';
import {TagCategory} from '@common/filter/interest-filter/interest-filter.vue';
import {useSolutionFilters} from '@components/solution-views/summary-filters';
import MainMenuWithPreferences from '@components/main-menu/main-menu-with-preferences.vue';
import MainMenuPreferencesBlock from '@components/main-menu/menu-trip-preferences.vue';
import {
  loadAvailableDomains,
  loadRecommendationDetails,
  updateSolutionTravelers,
  toggleSolutionTags,
  getAllSolutionFilters,
  getSolutionContext,
  getStartEndDates,
  getManualActivities,
  updateSolution,
  getTripId,
  getSolutionLoading,
} from '@/store/state/helpers';
import {formatDate, getListOfSolutionDays} from '@/store/state/utils';
import {getSolutionDates} from '@mobi-components/global-solution';
import {LunchTime} from '@mobi-components/amex-poi-details-view';
import {DateFormatter} from '@/services/date-helpers';
import SavedList from './exp-list/saved-places-list.vue';

const AvailableTabs = {
  SAVED_PLACES: 0,
  ITINERARY: 1,
};

export default {
  name: 'TripExplorePage',
  components: {
    TripContent,
    ExpList,
    TripBg,
    ToggleComponent,
    SummarySaveDialog,
    SolutionMap,
    MainMenuWithPreferences,
    MainMenuPreferencesBlock,
    SearchInput,
    AmexDropdown,
    ExpItem,
    InterestDropItem,
    SavedList,
  },

  setup(_, {root}) {
    const activeTab = ref(AvailableTabs.ITINERARY);
    const isSavedPlacesActive = computed(() => activeTab.value === AvailableTabs.SAVED_PLACES);
    const isItinerarysActive = computed(() => activeTab.value === AvailableTabs.ITINERARY);
    const openSavedPlaces = () => (activeTab.value = AvailableTabs.SAVED_PLACES);
    const openItinerary = () => (activeTab.value = AvailableTabs.ITINERARY);

    const isSidebarVisible = ref(false);
    const toggleSidebar = () => {
      isSidebarVisible.value = !isSidebarVisible.value;
    };
    const params = useParams();
    loadAvailableDomains(params.value.contextName);

    const {onRecommendationsOpen, destinationName, category, onShowPoiDetailsFromMap, solution, ...rest} =
      useExploreView(root);

    const query = useQueryParams();
    if (query.value.showRecommendations) {
      onRecommendationsOpen(query.value.activityId || '');
    }

    useSessionValidation();

    const isAmex = process.env.VUE_APP_AMEX_AUTH_ENABLED;
    const isHeaderVisible = process.env.VUE_APP_IS_HEADER_VISIBLE || false;
    const showPoweredByMobi = process.env.VUE_APP_THEME !== 'MOBI';

    const isSummaryMapActiveState = ref(false);
    const top = ref(null);

    const selectedPoiId = computed(() => {
      const params = useParams();
      return params.value.poiId || '';
    });

    watch(selectedPoiId, () => {
      if (isSummaryMapActiveState?.value) {
        onToggleSummaryMap();
      }
    });

    // ====================================================================================
    const availableCommonInterests = computed(() => {
      return getAllSolutionFilters().filter((x) => allovedInterestDomains.includes(x.domain));
    });

    const updateCommonStoreTags = async (filters, selectedFilters) => {
      // toggle tags in store
      const filtersTurnedOff = filters.value.filter((x) => x.value).map((x) => ({...x, value: false}));
      await toggleSolutionTags([...filtersTurnedOff, ...selectedFilters]);

      // use updateTripPreferences to update problem without re-submittingit again.
      await updateTripPreferences();
    };

    const {solutionTravlersFilter} = useSolutionFilters(root);

    // TODO: refactor this in common piece of code for all pages
    const onCommonFilterClick = (filter, category) => {
      const modalForFilter = getModalFilterConfig(filter.type);
      if (modalForFilter) {
        const configs = {
          interestsConfig: {
            get availableTags() {
              return [...availableCommonInterests.value, ...availableDestFlightFilters.value];
            },
            // if category is not set, we just set availableCategories to, and show first default category
            availableCategories: {
              [category || TagCategory.ACCOMMODATION]: true,
            },
            onSelectionChange: (tags) => updateCommonStoreTags(availableCommonInterests, tags),
          },

          travelersConfig: {
            get filterValue() {
              return solutionTravlersFilter.value;
            },
            onSelectionChange: async (value) => {
              // update travelers info in store
              updateSolutionTravelers(value);

              // update travelers info via API
              updateTripTravelersInfo();
            },
          },
        };

        const config = configs[modalForFilter.key];
        root.$modal
          .show(modalForFilter.modal, config)
          .then((updatedFilters) => {
            updatedFilters && config.onSelectionChange(updatedFilters);
          })
          .catch(() => {
            config.onSelectionChange([]);
          });
      }
    };
    // ==================================================================================

    const dateValueFormatted = computed(() => {
      const startDate = new Date(getStartEndDates().start);
      const endDate = new Date(getStartEndDates().end);

      return DateFormatter.formatDateRange(startDate, endDate);
    });

    const isSummaryMapActive = computed(() => {
      return isSummaryMapActiveState.value;
    });

    const onToggleSummaryMap = () => {
      isSummaryMapActiveState.value = !isSummaryMapActiveState.value;
    };

    const onShowMap = () => {
      isSummaryMapActiveState.value = true;
      root.$nextTick(() => {
        if (top.value) {
          top.value.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
      });
    };

    const {onBookingOpen} = useSummary(root);
    const {totalPrice} = useBookings(root);

    const loadAdditionalExperiences = async () => {
      await loadRecommendationDetails(ProblmSubmissionRoute.SOLUTION, getSolutionContext());
      return null;
    };

    const manualActivities = computed(() => {
      return getManualActivities().length > 0;
    });

    const solutionDates = computed(() => {
      if (!solution.value) {
        return [];
      }
      const days = getListOfSolutionDays(solution.value);
      return getSolutionDates(days).map((x, index) => ({
        ...x,
        label: `Day ${index + 1}`,
        description: formatDate(x.date),
      }));
    });

    const onUpdateSolution = async () => {
      const days = solutionDates.value;

      days.forEach((x) => {
        root.$emit('day-loading', {day: x.label, name: ''});
      });

      try {
        const newTripId = getTripId();
        await updateSolution(newTripId, ProblmSubmissionRoute.SOLUTION, [], LunchTime.NONE);
      } catch {
      } finally {
        days.forEach((x) => {
          root.$emit('day-loaded', x.label);
        });
        root.$emit('day-loaded', 'stay');
        openItinerary();
      }
    };

    const isSolutionLoading = computed(() => {
      return getSolutionLoading();
    });

    return {
      isSolutionLoading,
      solution,
      onCommonFilterClick,
      totalPrice,
      onBookingOpen,
      isAmex,
      isHeaderVisible,
      onRecommendationsOpen,
      ...rest,
      ...useSaveSolutionDialog(root),
      toggleSidebar,
      isSidebarVisible,
      manualActivities,
      onUpdateSolution,
      destinationName,
      isSummaryMapActive,
      onToggleSummaryMap,
      onShowMap,
      top,
      showPoweredByMobi,
      ...useCommonFind(category, onShowPoiDetailsFromMap, loadAdditionalExperiences),
      onShowPoiDetailsFromMap,
      dateValueFormatted,

      // tabs on sidebar
      isSavedPlacesActive,
      isItinerarysActive,
      openSavedPlaces,
      openItinerary,
    };
  },
};
</script>

<style scoped lang="scss">
@import '../solution-views/vue-transitions.scss';
@import '../summary-page/save-solution-dropdown.scss';
@import '../solution-views/explore-view/common-explore-view.scss';
.view-container {
  flex: 1;
  position: relative;
  // overflow: hidden;
  display: flex;
  flex-direction: column;
  --top-margin: 65px;
}
.trip-summary-wrapper {
  position: relative;
  // height: 100vh;
  // min-height: 600px;
  display: flex;
  flex-direction: column;
}

.mobiamex-tripsummary {
  flex: 1;
  position: relative;
  display: flex;
  width: 100vw;
  max-width: 1260px;
  margin: auto;
}

.backToTrip {
  border-bottom: 1px solid #e5e5e5;
  margin-left: 26px;
  padding: 26px 0 10px 18px;
  font-weight: 700;
  position: relative;
}
.backToTrip:hover {
  cursor: pointer;
}
.backToTrip::before {
  width: 8px;
  height: 8px;
  bottom: 14px;
  left: 0;
  content: '';
  position: absolute;
  background-image: url("data:image/svg+xml,%3Csvg width='11' height='9' viewBox='0 0 11 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.5 9L0.73686 0.750001L10.2631 0.75L5.5 9Z' fill='%23071D3B'/%3E%3C/svg%3E%0A");
  background-repeat: no-repeat;
  background-size: 8px;
  transform: rotate(90deg);
}

.box {
  background-color: #fff;
  border-radius: 20px 0 0 20px;
  box-shadow: 0px 0px 33px rgba(0, 0, 0, 0.13);
  overflow: hidden;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  display: flex;
  // overflow: scroll;
  flex-direction: column;
  z-index: 1;
  transform: translateZ(0);
}

.recommendations-view {
  position: absolute !important;
  top: 0;
  right: 0;
  left: 350px;
  height: auto;
}

.shrinkable {
  padding: 0;
  top: var(--top-margin);
}

.solution-img,
.shrink {
  max-width: 300px;
  border-radius: 10px 10px 0 0;
}

.sidebar {
  position: fixed;
  top: 115px;
  left: 50%;
  transform: translateX(-630px);
  bottom: 50px;
  z-index: 10;
  background: #fff;
  // transform: translateX(-100%);
  transition: transform 0.1s linear;
  box-shadow: 0px 0px 33px rgba(0, 0, 0, 0.13);
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-width: var(--widthSidebar);
}

.contentPane {
  position: static;
  padding-left: 330px;
  border-radius: none;
  box-shadow: none;
}

.sidebar.active {
  transform: translateX(0);
}

.tripBill {
  overflow: hidden;
}

.expanded {
  --max-content-width: 100%;
}

@media screen and (max-width: 1260px) {
  .sidebar {
    left: 0;
    transform: translateX(0);
    bottom: 0;
    top: 60px;
    border-radius: 0;
  }

  .solution-img {
    border-radius: 0;
  }
}
.exp-list {
  margin-top: 10px;
}

.recommendations-toggle {
  --gray-scroll-thumb: #fff;
  --white: #fff;
  --toggle-bg: #dadada;

  &.active {
    --toggle-bg: var(--recommendations-primary, #e9a43d);
    --primary: #fff;
  }
}

.trip-img-wrapper {
  min-height: 100px;
  position: relative;
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    top: 40%;
    left: 0;
    right: 0;
    z-index: 0;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.7) 0%);
  }
}

.trip-img-wrapper:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 100%);
}

.trip-header {
  z-index: 10;
}
.trip-button {
  margin-left: auto;
}

.header-actions {
  display: flex;
  flex: 1;
}

.filters {
  margin-right: auto;
  display: flex;
  align-items: center;
  flex: 1;
}

.filters > * + * {
  margin-left: 5px;
}

.filter-value {
  white-space: nowrap;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s linear;
  opacity: 1;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.powered-by-mobi-position {
  position: absolute;
  right: 0;
  top: 25px;
  z-index: 11;
}

.button-wrapper {
  z-index: 15;
}
</style>

<style lang="postcss">
.tour-step.strong-step {
  background: #ffffff;
  box-shadow: 0px 0px 33px rgba(0, 0, 0, 0.13);
  border-radius: 5px;
  min-width: 410px;

  & > div:before {
    background: #fff;
  }
}

.tour-step.strong-step .tour-content-header {
  font-style: normal;
  font-weight: 400;
  font-size: 26px;
  line-height: 22px;
  color: #333333;
  margin-bottom: 0;
  text-align: left;
}
.tour-step.strong-step .tour-content-body {
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 140%;
  color: #97999b;
  text-align: left;
  border-bottom: 1px solid #f1f1f1;
  padding-bottom: 25px;
}

.tour-svg-text.bold {
  fill: #333333;
}
.tour-svg-text {
  font-style: normal;

  font-size: 10px;
  line-height: 12px;
  text-align: center;

  fill: #858585;
}
.tour-actions {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-top: 25px;
}

.tour-btn {
  background: none;
  appearance: none;
  border: 0;
  cursor: pointer;

  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.01em;
  color: var(--primary-color, #2c70c9);
}

.tour-btn.tour-btn-primary {
  font-weight: 700;
}

.header {
  position: sticky;
  top: 0;
}

.explore-header {
  width: var(--page-container-width);
  margin: auto;
  display: flex;
  padding-left: 330px;
  overflow: visible;
  will-change: height;
  height: 150px;
  transition: height linear 0.3s;
  padding-left: calc((var(--widthSidebar)) + 15px);
  --margin-calc: calc(calc(100vw - var(--page-container-width)) / 2);
}
.map-container {
  width: 100%;
  left: 0;
  right: 0;
  --busyAreaWidth: calc(2 * var(--margin-calc) + 350px);
  --filters-width: calc(100vw - var(--busyAreaWidth));
  position: absolute;
  bottom: 0;
  top: 0;
  --page-container-width: var(--filters-width);
  --filters-wrapper-margin-left: 350px;
}
.explore-header.extended {
  height: 75vh;
}

.map-toggle-wrapper {
  margin-left: auto;
  position: absolute;
  right: 0px;
  bottom: 25px;
  z-index: 1;
}

.map-toggle {
  background: #ffffff;
  box-shadow: 0px 0px 33px rgba(0, 0, 0, 0.13);
  padding: 10px 20px;
  margin: 4.5px 0;
  display: inline-block;

  transition: 0.3s ease opacity;
  --gray-scroll-thumb: #fff;
  --white: #fff;
  --toggle-bg: #dadada;
  border-radius: 4px !important;
  color: #838e9d;

  .map-toggle-label {
    margin-left: 10px;
  }

  &.active {
    --toggle-bg: var(--btn-primary-color);
    --primary: #fff;
    .map-toggle-label {
      color: var(--btn-primary-color);
    }
  }
}

.map-holder {
  position: absolute;
  top: 0;
  left: 0;
  --map-height: 100%;
  height: 150px;
  width: 100%;
  transform: translateZ(0);
  z-index: 1;
  filter: grayscale();
  opacity: 0.3;
}

.map-holder.active {
  height: 75vh;
  filter: grayscale(0);
  opacity: 1;
}

/* HACK to fix main menu issues on explore page */
/* TODO: remove this when we rewamp page */
.explore-page.main-menu .container {
  max-width: unset;
  height: 65px;
  padding: 0 14px;
}

.trip-summary-btn {
  --radiusSmall: 5px;
  --shadingB-70: rgba(0, 0, 0, 0.7);
  --toneBw-0: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  min-width: 40px;
  height: 40px;
  border-radius: var(--radiusSmall);
  background-color: var(--shadingB-70);
  position: absolute;
  top: 10px;
  right: 10px;
  background-size: 14px;
  background-position: center;
  background-repeat: no-repeat;
  border: 1px solid var(--shadingB-70);
  transition: 0.3s ease border, 0.3s ease opacity;
  opacity: 0.8;
  z-index: 31;
  color: var(--toneBw-0);
}

.trip-summary-btn > span {
  font-size: 0%;
}

.trip-summary-btn:hover {
  opacity: 1;
  border-color: var(--toneBw-0);
}

.trip-header {
  position: absolute;
  bottom: 10px;
  left: 15px;
  color: #fff;
  font-size: 12px;
}

.trip-details-caption {
  font-size: 24px;
  font-family: var(--font-family);
}

.flights-header-wrapper {
  padding-left: 20px;
  margin-bottom: 10px;
}

.flights-header {
  border-bottom: 1px solid var(--toneBw-5);
  padding: 0 0 10px 0;
  font-size: var(--tSize-xs);
}
.book-trip-btn {
  /* background-color: var(--tonePrimary-100); */
  background-color: #e14645;
  color: var(--toneBw-0);
  height: 50px;
  padding: 0 14px;
  border: 0px;
  font-size: var(--tSize-sm);
  border-radius: var(--radiusSmall);
  cursor: pointer;
  line-height: 54px;
  width: 100%;
  justify-content: space-between;
  white-space: nowrap;
  font-weight: 500;
  flex: 1;
}

.book-trip-btn:disabled {
  background-color: var(--toneDark-40);
}

.book-trip-btn + .book-trip-btn {
  margin-left: 10px;
}

.update-trip-btns {
  z-index: 10;
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  height: 70px;
  overflow: hidden;
  padding: 10px;
  width: 100%;
}

.update-trip {
  background-color: var(--toneDark-100);
}

.header-wrapper {
  width: 100%;
  display: flex;
  padding: 25px 50px 25px 16px;
  max-width: var(--widthContainer);
  position: relative;
  align-items: flex-end;
}

.header-category {
  font-family: var(--fBase);
  color: var(--toneDark-100);
  font-size: var(--tSize-xl);
}

.header-back--explore {
  position: absolute;
  z-index: 1;
  bottom: 65px;
  .explore-btn {
    padding: 0;
  }
}
.explore-btn {
  font-size: var(--tSize-sm);
  appearance: none;
  border: none;
  background: none;
  color: var(--toneDark-100);
  cursor: pointer;
}

.search-wrapper {
  margin-left: auto;
  margin-right: 10px;
  position: absolute;
  right: 180px;
  bottom: 29px;
  z-index: 3;
}
</style>


// sidebar nav
<style scoped>
.explore-nav {
  display: flex;
  justify-content: flex-start;
  margin: 10px 0 10px 20px;
  border-bottom: 1px solid var(--toneBw-5);
  padding: 10px;
}

.exp-nav-tab {
  border: none;
  background: none;
  color: var(--toneDark-100, #071d3b);
  font-size: var(--tSize-xs);
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  opacity: 0.5;
  padding: 10px;
  cursor: pointer;
}

.exp-nav-tab:hover {
  opacity: 0.75;
}

.exp-nav-tab.active:hover,
.exp-nav-tab.active {
  opacity: 1;
  box-shadow: 0 8px 0px 0px #fff, 0 10px 0 0 var(--toneDark-100, #071d3b);
}
</style>